<template>
  <div :class="['navigation', { isHome: isHome }]">
    <div class="container nav-wrapper">
      <nav
        class="navbar bg-transparent navbar-expand-md navbar-dark bg-dark px-0"
      >
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="social d-block d-md-none">
          <img src="@/assets/images/instagram.svg" alt="Instagram Logo" />
        </div>
        <router-link class="navbar-brand ml-auto" to="/">
          <img src="@/assets/images/logo-sm.svg" alt="WMS Logo" />
        </router-link>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li :class="['nav-item', { active: isHome }]">
              <router-link class="nav-link" to="/">
                Inicio
                <span class="sr-only">(current)</span>
              </router-link>
            </li>

            <li
              :class="[
                'nav-item',
                currentPage.includes('servicios') ? activeClass : '',
              ]"
            >
              <router-link class="nav-link" to="/servicios"
                >Servicios</router-link
              >
            </li>
            <li
              :class="[
                'nav-item',
                currentPage.includes('nosotros') ? activeClass : '',
              ]"
            >
              <router-link class="nav-link" to="/nosotros"
                >Nosotros</router-link
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                v-scroll-to="{ el: '#contact', duration: 1500 }"
                >Contacto</a
              >
            </li>
            <li class="nav-item">
              <a
                data-toggle="modal"
                data-target="#galeria"
                class="nav-link"
                href="#"
                >Galeria</a
              >
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  data() {
    return {
      activeClass: 'active',
    }
  },
  computed: {
    currentPage() {
      return this.$route.path
    },
    isHome() {
      if (this.$route.path === '/') {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    window.$('.navbar-collapse a').click(function() {
      window.$('.navbar-collapse').collapse('hide')
    })
  },
}
</script>

<style lang="scss" scoped>
.navigation {
  position: relative;
  z-index: 999;
  width: 100%;
  height: 72px;
  background-color: $azul;

  .navbar-collapse {
    background-color: $azul;
    width: 100vw;
    margin-left: -15px;
    margin-right: -15px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .navbar-nav {
    flex-direction: row;
    padding: 0 0px;
    align-items: center;
    justify-content: space-around;
  }
  .navbar-toggler {
    border: none;
    padding: 0;
    margin-right: 20px;
  }
  .navbar-toggler-icon {
    width: 20px;
  }

  .social {
    max-width: 18px;
    line-height: 1;
    margin: 0 16px;
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    &::before {
      position: absolute;
      left: -16px;

      height: 18px;
      width: 1px;
      content: '';
      display: block;
      background-color: #fff;
    }
  }
  .navbar-brand {
    padding-top: 0;
    img {
      max-width: 77px;
    }
  }
  .nav-item {
    a.nav-link {
      color: #fff;
    }
    &.active a.nav-link {
      color: $naranja;
    }
  }
  .navbar-dark .navbar-nav .nav-link:hover {
    color: $primary;
  }
}

@media screen and (min-width: 768px) {
  .navigation.isHome {
    background: rgb(0, 0, 0);
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.5021186440677966) 31%,
      rgba(0, 0, 0, 0.9427966101694916) 100%
    );
    position: absolute;

    .navbar-collapse {
      background-color: transparent;
    }
  }
  .navbar-brand {
    order: 2;
  }
}
@media (min-width: 1200px) {
  .navigation {
    .navbar-nav {
    }
  }
}
</style>
